import { Button, Form, Input } from 'antd';
import { useForm } from 'antd/es/form/Form';
import React, { useEffect } from 'react';
import { useColors } from './ColorStore';

function Edit(props) {
    let [form] = useForm();
    let { updateColor, ed } = useColors()
    useEffect(() => {
        form.setFieldsValue(ed)
    }, [ed])
    return (
        <Form form={form} layout="vertical" onFinish={updateColor} encType="multipart/form-data">
            <Form.Item name={'id'} hidden>
                <Input />
            </Form.Item>
            <Form.Item label="O'zbekcha nomi" name="nameuz" rules={[{ required: true, message: 'Please input your name!' }]}>
                <Input />
            </Form.Item>
            <Form.Item label="Ruscha nomi" name="nameru" rules={[{ required: true, message: 'Please input your description!' }]}>
                <Input />
            </Form.Item>
            <Form.Item label="Rangi" name="color" rules={[{ required: true, message: 'Please input your color!' }]}>
                <Input type='color' />
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit">O'zgartirish</Button>
            </Form.Item>
        </Form>
    );
}

export default Edit;